import {
  computed,
  Ref,
} from '@nuxtjs/composition-api';

import { ProductInterface } from '~/modules/GraphQL/types';
import { useProductPageStore } from '~/stores/productPage';

import type { UseProductPageInterface } from './useProductPage';

export function useProductPage(): UseProductPageInterface {
  const productPageStore = useProductPageStore();
  const reviews = computed(() => productPageStore.reviews);
  const productsInRange = computed(() => productPageStore.productsInRange);
  const loadReviews = (product: Ref<ProductInterface>) => productPageStore.loadReviews(product);
  const loadProductsInRange = (skus: number[]) => productPageStore.loadProductsInRange(skus);

  return {
    loadReviews,
    loadProductsInRange,
    reviews,
    productsInRange,
  };
}

export * from './useProductPage';
export default useProductPage;
